jQuery(document).ready(function ($) {
    const input = document.getElementById('kompatybilnosc-sprzetu');

    $('.btn-increase').on('click', function () {
        input.stepUp();
    });

    $('.btn-decrease').on('click', function () {
        input.stepDown();
    });
});
